if (!customElements.get('second-buy-box')) {
  customElements.define(
    'second-buy-box',
    class SecondBuyBox extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.section;
        this.host = this.querySelector('[data-tiers-host]');
        this.button = this.querySelector('[data-second-submit]');
        this.pill = this.querySelector('[data-second-price]');
        this.label = this.querySelector('[data-second-label]');
        this.defaultLabel = this.label ? this.label.textContent.trim() : '';
        this.fallbackHtml = this.host ? this.host.innerHTML : '';

        this.onTierChange = () => this.sync();
        this.onSectionLoad = () => this.bind();
        this.onSubmit = (event) => {
          if (event.submitter === this.button) this.setLoading(true);
        };

        document.addEventListener('bangle:tier-change', this.onTierChange);
        document.addEventListener('shopify:section:load', this.onSectionLoad);

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribers = [
            subscribe(PUB_SUB_EVENTS.cartUpdate, () => this.setLoading(false)),
            subscribe(PUB_SUB_EVENTS.cartError, () => this.setLoading(false)),
          ];
        }

        this.bind();
      }

      disconnectedCallback() {
        document.removeEventListener('bangle:tier-change', this.onTierChange);
        document.removeEventListener('shopify:section:load', this.onSectionLoad);
        if (this.unsubscribers) this.unsubscribers.forEach((unsubscribe) => unsubscribe());
        if (this.ctaObserver) this.ctaObserver.disconnect();
        if (this.form) this.form.removeEventListener('submit', this.onSubmit);
      }

      /* Find the hero (product-info) and wire this box to its form and tiers. */
      bind() {
        const info = document.querySelector('product-info');
        const source = info ? info.querySelector('bangle-tiers') : null;
        const form = info ? info.querySelector('form[data-type="add-to-cart-form"]') : null;
        const cta = info ? info.querySelector('.product-form__submit') : null;

        if (!source || !form || !cta || !this.host || !this.button) {
          this.source = null;
          if (this.host) this.host.innerHTML = this.fallbackHtml;
          this.button.hidden = true;
          return;
        }

        if (this.form && this.form !== form) this.form.removeEventListener('submit', this.onSubmit);
        this.source = source;
        this.form = form;
        this.cta = cta;

        this.build();

        /* form.id can be shadowed by the hidden input named "id"; read the attribute. */
        this.button.setAttribute('form', form.getAttribute('id'));
        this.button.hidden = false;
        form.removeEventListener('submit', this.onSubmit);
        form.addEventListener('submit', this.onSubmit);

        if (this.ctaObserver) this.ctaObserver.disconnect();
        this.ctaObserver = new MutationObserver(() => this.syncButton());
        this.ctaObserver.observe(cta, {
          attributes: true,
          attributeFilter: ['disabled'],
          childList: true,
          subtree: true,
          characterData: true,
        });

        this.syncButton();
        this.sync();
      }

      /* Clone the hero's tier fieldset so the markup has one source. */
      build() {
        const fieldset = this.source.querySelector('fieldset');
        if (!fieldset) return;
        const clone = fieldset.cloneNode(true);
        clone.id = `SecondTiers-${this.sectionId}`;
        clone.querySelectorAll('[data-shopify-editor-block]').forEach((el) => el.removeAttribute('data-shopify-editor-block'));
        clone.querySelectorAll('input[type="radio"]').forEach((input) => {
          const oldId = input.id;
          const newId = `${oldId}-second-${this.sectionId}`;
          const label = clone.querySelector(`label[for="${oldId}"]`);
          input.id = newId;
          input.name = `second-tier-${this.sectionId}`;
          if (label) label.setAttribute('for', newId);
        });
        clone.addEventListener('change', (event) => {
          const input = event.target;
          if (!input.matches('input[type="radio"]')) return;
          const heroInput = this.source.querySelector(`input[type="radio"][value="${input.value}"]`);
          if (heroInput && !heroInput.checked) {
            heroInput.checked = true;
            heroInput.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
        this.host.replaceChildren(clone);
      }

      /* Mirror the hero's selected tier and its (variant-aware) prices. */
      sync() {
        if (!this.source || !this.host) return;
        const heroChecked = this.source.querySelector('input[type="radio"]:checked');
        this.host.querySelectorAll('[data-tier-id]').forEach((tier) => {
          const fresh = this.source.querySelector(`[data-tier-id="${tier.dataset.tierId}"] [data-tier-pricing]`);
          const current = tier.querySelector('[data-tier-pricing]');
          if (fresh && current) {
            current.innerHTML = fresh.innerHTML;
            current.dataset.total = fresh.dataset.total || '';
          }
          const input = tier.querySelector('input[type="radio"]');
          if (input && heroChecked) input.checked = input.value === heroChecked.value;
        });
        const detail = this.source.lastDetail;
        if (this.pill && detail && detail.total) this.pill.textContent = detail.total;
      }

      /* Mirror the hero CTA's disabled state and sold-out label. */
      syncButton() {
        if (!this.button || !this.cta) return;
        const disabled = this.cta.hasAttribute('disabled');
        this.button.toggleAttribute('disabled', disabled);
        if (!this.label) return;
        if (disabled) {
          const ctaLabel = this.cta.querySelector('span');
          if (ctaLabel) this.label.textContent = ctaLabel.textContent.trim();
        } else {
          this.label.textContent = this.defaultLabel;
        }
      }

      setLoading(isLoading) {
        if (!this.button) return;
        this.button.classList.toggle('loading', isLoading);
        this.button.toggleAttribute('aria-busy', isLoading);
        const spinner = this.button.querySelector('.loading__spinner');
        if (spinner) spinner.classList.toggle('hidden', !isLoading);
        window.clearTimeout(this.loadingTimeout);
        if (isLoading) {
          this.loadingTimeout = window.setTimeout(() => this.setLoading(false), 8000);
        }
      }
    }
  );
}
